/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ConfigMapDTO } from '../models/config-map-dto';
import { CronJobDTO } from '../models/cron-job-dto';
import { DaemonSetDTO } from '../models/daemon-set-dto';
import { DeploymentDTO } from '../models/deployment-dto';
import { HorizontalPodAutoscalerDTO } from '../models/horizontal-pod-autoscaler-dto';
import { IngressRulesDTO } from '../models/ingress-rules-dto';
import { IngressDTO } from '../models/ingress-dto';
import { JobDTO } from '../models/job-dto';
import { PodDTO } from '../models/pod-dto';
import { StreamingResponseBody } from '../models/streaming-response-body';
import { PersistentVolumeDTO } from '../models/persistent-volume-dto';
import { PersistentVolumeClaimDTO } from '../models/persistent-volume-claim-dto';
import { ReplicasetDTO } from '../models/replicaset-dto';
import { SecretDTO } from '../models/secret-dto';
import { ServiceDTO } from '../models/service-dto';
import { StatefulSetDTO } from '../models/stateful-set-dto';
import { EventDTO } from '../models/event-dto';
import { Container } from '../models/container';
import { ContainerDTO } from '../models/container-dto';

/**
 * Ui Kubernetes Explorer Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiKubernetesExplorerControllerService extends __BaseService {
  static readonly listConfigMapByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/configMaps';
  static readonly getConfigMapDataUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/configMaps/{configMapName}';
  static readonly listCronJobByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/cronJobs';
  static readonly listDaemonSetsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/daemonSets';
  static readonly listDeploymentsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/deployments';
  static readonly getPodsForDeploymentUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/deployments/{deploymentName}';
  static readonly listHpaByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/hpa';
  static readonly getAllIngressRulesForClusterUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/ingress-rules';
  static readonly listIngressesByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/ingresses';
  static readonly listJobsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/jobs';
  static readonly listPodsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/pods';
  static readonly containerLogsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/pods/{podName}/{containerName}/logs';
  static readonly listPVByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/pv';
  static readonly listPVCByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/pvc';
  static readonly listReplicasetsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/replicasets';
  static readonly listSecretsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/secrets';
  static readonly getSecretsDataUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/secrets/{secretName}';
  static readonly listServicesByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/services';
  static readonly listStatefulsetsLabelsByLabelsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/statefulsets';
  static readonly listEventsByK8sResourceUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/{k8sResourceType}/{k8sResourceName}/events';
  static readonly getManifestUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/{k8sResourceType}/{k8sResourceName}/manifest';
  static readonly listContainersInPodUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/{podName}/containers';
  static readonly listContainersInPodV2UsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8s-explorer/{podName}/v2/containers';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * listConfigMapByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListConfigMapByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listConfigMapByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListConfigMapByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ConfigMapDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/configMaps`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ConfigMapDTO>>;
      }),
    );
  }
  /**
   * listConfigMapByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListConfigMapByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listConfigMapByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListConfigMapByLabelsUsingGETParams,
  ): __Observable<Array<ConfigMapDTO>> {
    return this.listConfigMapByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ConfigMapDTO>),
    );
  }

  /**
   * getConfigMapData
   * @param params The `UiKubernetesExplorerControllerService.GetConfigMapDataUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `configMapName`: configMapName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getConfigMapDataUsingGETResponse(
    params: UiKubernetesExplorerControllerService.GetConfigMapDataUsingGETParams,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/configMaps/${encodeURIComponent(
          String(params.configMapName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * getConfigMapData
   * @param params The `UiKubernetesExplorerControllerService.GetConfigMapDataUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `configMapName`: configMapName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getConfigMapDataUsingGET(
    params: UiKubernetesExplorerControllerService.GetConfigMapDataUsingGETParams,
  ): __Observable<{}> {
    return this.getConfigMapDataUsingGETResponse(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * listCronJobByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListCronJobByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listCronJobByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListCronJobByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<CronJobDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/cronJobs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CronJobDTO>>;
      }),
    );
  }
  /**
   * listCronJobByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListCronJobByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listCronJobByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListCronJobByLabelsUsingGETParams,
  ): __Observable<Array<CronJobDTO>> {
    return this.listCronJobByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<CronJobDTO>),
    );
  }

  /**
   * listDaemonSetsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListDaemonSetsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listDaemonSetsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListDaemonSetsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<DaemonSetDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/daemonSets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DaemonSetDTO>>;
      }),
    );
  }
  /**
   * listDaemonSetsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListDaemonSetsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listDaemonSetsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListDaemonSetsByLabelsUsingGETParams,
  ): __Observable<Array<DaemonSetDTO>> {
    return this.listDaemonSetsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<DaemonSetDTO>),
    );
  }

  /**
   * listDeploymentsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListDeploymentsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listDeploymentsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListDeploymentsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<DeploymentDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/deployments`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeploymentDTO>>;
      }),
    );
  }
  /**
   * listDeploymentsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListDeploymentsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listDeploymentsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListDeploymentsByLabelsUsingGETParams,
  ): __Observable<Array<DeploymentDTO>> {
    return this.listDeploymentsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<DeploymentDTO>),
    );
  }

  /**
   * getPodsForDeployment
   * @param params The `UiKubernetesExplorerControllerService.GetPodsForDeploymentUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `deploymentName`: deploymentName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getPodsForDeploymentUsingGETResponse(
    params: UiKubernetesExplorerControllerService.GetPodsForDeploymentUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/deployments/${encodeURIComponent(
          String(params.deploymentName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getPodsForDeployment
   * @param params The `UiKubernetesExplorerControllerService.GetPodsForDeploymentUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `deploymentName`: deploymentName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getPodsForDeploymentUsingGET(
    params: UiKubernetesExplorerControllerService.GetPodsForDeploymentUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getPodsForDeploymentUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * listHpaByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListHpaByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listHpaByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListHpaByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<HorizontalPodAutoscalerDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/hpa`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<HorizontalPodAutoscalerDTO>>;
      }),
    );
  }
  /**
   * listHpaByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListHpaByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listHpaByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListHpaByLabelsUsingGETParams,
  ): __Observable<Array<HorizontalPodAutoscalerDTO>> {
    return this.listHpaByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<HorizontalPodAutoscalerDTO>),
    );
  }

  /**
   * getAllIngressRulesForCluster
   * @param clusterId clusterId
   * @return OK
   */
  getAllIngressRulesForClusterUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<Array<IngressRulesDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/k8s-explorer/ingress-rules`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<IngressRulesDTO>>;
      }),
    );
  }
  /**
   * getAllIngressRulesForCluster
   * @param clusterId clusterId
   * @return OK
   */
  getAllIngressRulesForClusterUsingGET(
    clusterId: string,
  ): __Observable<Array<IngressRulesDTO>> {
    return this.getAllIngressRulesForClusterUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as Array<IngressRulesDTO>),
    );
  }

  /**
   * listIngressesByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListIngressesByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listIngressesByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListIngressesByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<IngressDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/ingresses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<IngressDTO>>;
      }),
    );
  }
  /**
   * listIngressesByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListIngressesByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listIngressesByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListIngressesByLabelsUsingGETParams,
  ): __Observable<Array<IngressDTO>> {
    return this.listIngressesByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<IngressDTO>),
    );
  }

  /**
   * listJobsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListJobsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listJobsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListJobsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<JobDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/jobs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<JobDTO>>;
      }),
    );
  }
  /**
   * listJobsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListJobsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listJobsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListJobsByLabelsUsingGETParams,
  ): __Observable<Array<JobDTO>> {
    return this.listJobsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<JobDTO>),
    );
  }

  /**
   * listPodsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListPodsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listPodsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListPodsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<PodDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/pods`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PodDTO>>;
      }),
    );
  }
  /**
   * listPodsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListPodsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listPodsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListPodsByLabelsUsingGETParams,
  ): __Observable<Array<PodDTO>> {
    return this.listPodsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<PodDTO>),
    );
  }

  /**
   * containerLogs
   * @param params The `UiKubernetesExplorerControllerService.ContainerLogsUsingGETParams` containing the following parameters:
   *
   * - `tail`: tail
   *
   * - `podName`: podName
   *
   * - `labels`: labels
   *
   * - `containerName`: containerName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  containerLogsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ContainerLogsUsingGETParams,
  ): __Observable<__StrictHttpResponse<StreamingResponseBody>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.tail != null)
      __params = __params.set('tail', params.tail.toString());

    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/pods/${encodeURIComponent(
          String(params.podName),
        )}/${encodeURIComponent(String(params.containerName))}/logs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StreamingResponseBody>;
      }),
    );
  }
  /**
   * containerLogs
   * @param params The `UiKubernetesExplorerControllerService.ContainerLogsUsingGETParams` containing the following parameters:
   *
   * - `tail`: tail
   *
   * - `podName`: podName
   *
   * - `labels`: labels
   *
   * - `containerName`: containerName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  containerLogsUsingGET(
    params: UiKubernetesExplorerControllerService.ContainerLogsUsingGETParams,
  ): __Observable<StreamingResponseBody> {
    return this.containerLogsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as StreamingResponseBody),
    );
  }

  /**
   * listPVByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListPVByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listPVByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListPVByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<PersistentVolumeDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/pv`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PersistentVolumeDTO>>;
      }),
    );
  }
  /**
   * listPVByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListPVByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listPVByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListPVByLabelsUsingGETParams,
  ): __Observable<Array<PersistentVolumeDTO>> {
    return this.listPVByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<PersistentVolumeDTO>),
    );
  }

  /**
   * listPVCByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListPVCByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listPVCByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListPVCByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<PersistentVolumeClaimDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/pvc`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PersistentVolumeClaimDTO>>;
      }),
    );
  }
  /**
   * listPVCByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListPVCByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listPVCByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListPVCByLabelsUsingGETParams,
  ): __Observable<Array<PersistentVolumeClaimDTO>> {
    return this.listPVCByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<PersistentVolumeClaimDTO>),
    );
  }

  /**
   * listReplicasetsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListReplicasetsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listReplicasetsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListReplicasetsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ReplicasetDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/replicasets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReplicasetDTO>>;
      }),
    );
  }
  /**
   * listReplicasetsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListReplicasetsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listReplicasetsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListReplicasetsByLabelsUsingGETParams,
  ): __Observable<Array<ReplicasetDTO>> {
    return this.listReplicasetsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ReplicasetDTO>),
    );
  }

  /**
   * listSecretsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListSecretsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listSecretsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListSecretsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<SecretDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/secrets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SecretDTO>>;
      }),
    );
  }
  /**
   * listSecretsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListSecretsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listSecretsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListSecretsByLabelsUsingGETParams,
  ): __Observable<Array<SecretDTO>> {
    return this.listSecretsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<SecretDTO>),
    );
  }

  /**
   * getSecretsData
   * @param params The `UiKubernetesExplorerControllerService.GetSecretsDataUsingGETParams` containing the following parameters:
   *
   * - `secretName`: secretName
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getSecretsDataUsingGETResponse(
    params: UiKubernetesExplorerControllerService.GetSecretsDataUsingGETParams,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/secrets/${encodeURIComponent(
          String(params.secretName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * getSecretsData
   * @param params The `UiKubernetesExplorerControllerService.GetSecretsDataUsingGETParams` containing the following parameters:
   *
   * - `secretName`: secretName
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getSecretsDataUsingGET(
    params: UiKubernetesExplorerControllerService.GetSecretsDataUsingGETParams,
  ): __Observable<{}> {
    return this.getSecretsDataUsingGETResponse(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * listServicesByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListServicesByLabelsUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `labels`: labels
   *
   * @return OK
   */
  listServicesByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListServicesByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ServiceDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/services`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ServiceDTO>>;
      }),
    );
  }
  /**
   * listServicesByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListServicesByLabelsUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `labels`: labels
   *
   * @return OK
   */
  listServicesByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListServicesByLabelsUsingGETParams,
  ): __Observable<Array<ServiceDTO>> {
    return this.listServicesByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ServiceDTO>),
    );
  }

  /**
   * listStatefulsetsLabelsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListStatefulsetsLabelsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listStatefulsetsLabelsByLabelsUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListStatefulsetsLabelsByLabelsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<StatefulSetDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/statefulsets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<StatefulSetDTO>>;
      }),
    );
  }
  /**
   * listStatefulsetsLabelsByLabels
   * @param params The `UiKubernetesExplorerControllerService.ListStatefulsetsLabelsByLabelsUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listStatefulsetsLabelsByLabelsUsingGET(
    params: UiKubernetesExplorerControllerService.ListStatefulsetsLabelsByLabelsUsingGETParams,
  ): __Observable<Array<StatefulSetDTO>> {
    return this.listStatefulsetsLabelsByLabelsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<StatefulSetDTO>),
    );
  }

  /**
   * listEventsByK8sResource
   * @param params The `UiKubernetesExplorerControllerService.ListEventsByK8sResourceUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `k8sResourceType`: k8sResourceType
   *
   * - `k8sResourceName`: k8sResourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listEventsByK8sResourceUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListEventsByK8sResourceUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<EventDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/${encodeURIComponent(
          String(params.k8sResourceType),
        )}/${encodeURIComponent(String(params.k8sResourceName))}/events`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EventDTO>>;
      }),
    );
  }
  /**
   * listEventsByK8sResource
   * @param params The `UiKubernetesExplorerControllerService.ListEventsByK8sResourceUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `k8sResourceType`: k8sResourceType
   *
   * - `k8sResourceName`: k8sResourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listEventsByK8sResourceUsingGET(
    params: UiKubernetesExplorerControllerService.ListEventsByK8sResourceUsingGETParams,
  ): __Observable<Array<EventDTO>> {
    return this.listEventsByK8sResourceUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<EventDTO>),
    );
  }

  /**
   * getManifest
   * @param params The `UiKubernetesExplorerControllerService.GetManifestUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `k8sResourceType`: k8sResourceType
   *
   * - `k8sResourceName`: k8sResourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getManifestUsingGETResponse(
    params: UiKubernetesExplorerControllerService.GetManifestUsingGETParams,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/${encodeURIComponent(
          String(params.k8sResourceType),
        )}/${encodeURIComponent(String(params.k8sResourceName))}/manifest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * getManifest
   * @param params The `UiKubernetesExplorerControllerService.GetManifestUsingGETParams` containing the following parameters:
   *
   * - `labels`: labels
   *
   * - `k8sResourceType`: k8sResourceType
   *
   * - `k8sResourceName`: k8sResourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getManifestUsingGET(
    params: UiKubernetesExplorerControllerService.GetManifestUsingGETParams,
  ): __Observable<string> {
    return this.getManifestUsingGETResponse(params).pipe(
      __map((_r) => _r.body as string),
    );
  }

  /**
   * listContainersInPod
   * @param params The `UiKubernetesExplorerControllerService.ListContainersInPodUsingGETParams` containing the following parameters:
   *
   * - `podName`: podName
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listContainersInPodUsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListContainersInPodUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<Container>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/${encodeURIComponent(
          String(params.podName),
        )}/containers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Container>>;
      }),
    );
  }
  /**
   * listContainersInPod
   * @param params The `UiKubernetesExplorerControllerService.ListContainersInPodUsingGETParams` containing the following parameters:
   *
   * - `podName`: podName
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listContainersInPodUsingGET(
    params: UiKubernetesExplorerControllerService.ListContainersInPodUsingGETParams,
  ): __Observable<Array<Container>> {
    return this.listContainersInPodUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<Container>),
    );
  }

  /**
   * listContainersInPodV2
   * @param params The `UiKubernetesExplorerControllerService.ListContainersInPodV2UsingGETParams` containing the following parameters:
   *
   * - `podName`: podName
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listContainersInPodV2UsingGETResponse(
    params: UiKubernetesExplorerControllerService.ListContainersInPodV2UsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ContainerDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.labels != null)
      __params = __params.set('labels', params.labels.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8s-explorer/${encodeURIComponent(
          String(params.podName),
        )}/v2/containers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ContainerDTO>>;
      }),
    );
  }
  /**
   * listContainersInPodV2
   * @param params The `UiKubernetesExplorerControllerService.ListContainersInPodV2UsingGETParams` containing the following parameters:
   *
   * - `podName`: podName
   *
   * - `labels`: labels
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listContainersInPodV2UsingGET(
    params: UiKubernetesExplorerControllerService.ListContainersInPodV2UsingGETParams,
  ): __Observable<Array<ContainerDTO>> {
    return this.listContainersInPodV2UsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ContainerDTO>),
    );
  }
}

module UiKubernetesExplorerControllerService {
  /**
   * Parameters for listConfigMapByLabelsUsingGET
   */
  export interface ListConfigMapByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getConfigMapDataUsingGET
   */
  export interface GetConfigMapDataUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * configMapName
     */
    configMapName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listCronJobByLabelsUsingGET
   */
  export interface ListCronJobByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listDaemonSetsByLabelsUsingGET
   */
  export interface ListDaemonSetsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listDeploymentsByLabelsUsingGET
   */
  export interface ListDeploymentsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getPodsForDeploymentUsingGET
   */
  export interface GetPodsForDeploymentUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * deploymentName
     */
    deploymentName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listHpaByLabelsUsingGET
   */
  export interface ListHpaByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listIngressesByLabelsUsingGET
   */
  export interface ListIngressesByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listJobsByLabelsUsingGET
   */
  export interface ListJobsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listPodsByLabelsUsingGET
   */
  export interface ListPodsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for containerLogsUsingGET
   */
  export interface ContainerLogsUsingGETParams {
    /**
     * tail
     */
    tail: number;

    /**
     * podName
     */
    podName: string;

    /**
     * labels
     */
    labels: any;

    /**
     * containerName
     */
    containerName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listPVByLabelsUsingGET
   */
  export interface ListPVByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listPVCByLabelsUsingGET
   */
  export interface ListPVCByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listReplicasetsByLabelsUsingGET
   */
  export interface ListReplicasetsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listSecretsByLabelsUsingGET
   */
  export interface ListSecretsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getSecretsDataUsingGET
   */
  export interface GetSecretsDataUsingGETParams {
    /**
     * secretName
     */
    secretName: string;

    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listServicesByLabelsUsingGET
   */
  export interface ListServicesByLabelsUsingGETParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * labels
     */
    labels?: any;
  }

  /**
   * Parameters for listStatefulsetsLabelsByLabelsUsingGET
   */
  export interface ListStatefulsetsLabelsByLabelsUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listEventsByK8sResourceUsingGET
   */
  export interface ListEventsByK8sResourceUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * k8sResourceType
     */
    k8sResourceType:
      | 'Deployment'
      | 'Pod'
      | 'DaemonSet'
      | 'StatefulSet'
      | 'HorizontalPodAutoscaler'
      | 'ReplicaSet'
      | 'Job'
      | 'CronJob'
      | 'Ingress'
      | 'PersistentVolumeClaim'
      | 'PersistentVolume'
      | 'ConfigMaps';

    /**
     * k8sResourceName
     */
    k8sResourceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getManifestUsingGET
   */
  export interface GetManifestUsingGETParams {
    /**
     * labels
     */
    labels: any;

    /**
     * k8sResourceType
     */
    k8sResourceType:
      | 'Deployment'
      | 'Pod'
      | 'DaemonSet'
      | 'StatefulSet'
      | 'HorizontalPodAutoscaler'
      | 'ReplicaSet'
      | 'Job'
      | 'CronJob'
      | 'Ingress'
      | 'PersistentVolumeClaim'
      | 'PersistentVolume'
      | 'ConfigMaps';

    /**
     * k8sResourceName
     */
    k8sResourceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listContainersInPodUsingGET
   */
  export interface ListContainersInPodUsingGETParams {
    /**
     * podName
     */
    podName: string;

    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listContainersInPodV2UsingGET
   */
  export interface ListContainersInPodV2UsingGETParams {
    /**
     * podName
     */
    podName: string;

    /**
     * labels
     */
    labels: any;

    /**
     * clusterId
     */
    clusterId: string;
  }
}

export { UiKubernetesExplorerControllerService };
